export default __webpack_public_path__ + "static/media/logo-cursos-de-ofimatica.1f952a59.webp";